// extracted by mini-css-extract-plugin
export default {"controls":"controls---SCjIl","delay":"delay---S1Dfo","buttons":"buttons---xxMqY"};